import { render, staticRenderFns } from "./CustomerFormatField.vue?vue&type=template&id=2a361ff0&scoped=true&"
import script from "./CustomerFormatField.vue?vue&type=script&lang=js&"
export * from "./CustomerFormatField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a361ff0",
  null
  
)

export default component.exports